import { render } from "./PageTopo.vue?vue&type=template&id=5c09aa59"
import script from "./PageTopo.vue?vue&type=script&lang=js"
export * from "./PageTopo.vue?vue&type=script&lang=js"

import "./PageTopo.vue?vue&type=style&index=0&id=5c09aa59&lang=css"
import "./PageTopo.vue?vue&type=style&index=1&id=5c09aa59&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__